import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Hobby4SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      fillRule="evenodd"
      d="m5.513 2.433-1.75 4.724a1 1 0 0 1-.937.653H0v-1.5H2.478L4.567.67c.32-.864 1.54-.872 1.87-.011l4.077 10.597 1.727-4.318a1 1 0 0 1 .928-.628H16v1.5h-2.492l-2.075 5.186c-.338.845-1.535.837-1.862-.012L5.513 2.434Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Hobby4SVG;
